import React, { useEffect } from "react";
import { useMap  } from "react-leaflet";
import { OpenStreetMapProvider, GeoSearchControl } from "leaflet-geosearch";

import 'leaflet-geosearch/dist/geosearch.css'; // Ensure you have this in your project
import './MapSearch.css';

const MapSearch = () => {
  const map = useMap();
 const provider = new OpenStreetMapProvider();
   
    const searchControl = new GeoSearchControl({
      provider,
      notFoundMessage: 'Sorry, that address could not be found.',
      style: 'bar',
      position: 'topright',
      showMarker: false,
      showPopup: true,
      autoClose: false,
      retainZoomLevel: false,
      animateZoom: true,
      openSearchOnLoad:false,
      keepResult: false,
      autoComplete: true, 
      popupFormat: ({ query, result }) => query ||'No label', 
      resultFormat: ({ result }) =>      result.label || 'No label' , 
      maxMarkers: 1, // optional: number 
      searchLabel: 'Enter Address',
    });
    map.on('geosearch/showlocation', (e)=>{
   
    });

  useEffect(() => {
    if (!map) {
   
      return;
    }
   

     map.addControl(searchControl);
 
    return () =>   map.removeControl(searchControl)

  }, [map]);

return null
};

export default MapSearch ;